import axios from 'axios';
import moment from 'moment';
import errorHandlerFactory from './errorHandler';
import { adaptSummaryFilters } from './adapters/filterAdapters';
import * as appConstants from '../common/constants';
const loadError = thingToLoad => errorHandlerFactory(`An error occured when fetching ${thingToLoad}.`);

export const getAvailableFilterValues = location => axios.get(location)
    .then(r => r.data.map(i => ({ title: i, value: i })));

export const getFileAvailability = (filters = []) => {
        const filterToday = filters.find(x => x.value && x.value.today);
        if (filterToday && filterToday.value && filterToday.value.today) {
            return axios.get(`/Jobs/DailyBatchHistByDates/${moment().format(appConstants.dateFormat)}`)
                .then(r => r.data).catch(loadError('Daily Batch History'));
        }
        const filterObject = adaptSummaryFilters(filters);
        const newRequestObject = {
            startDate: filterObject.runStartDate,
            endDate: filterObject.runEndDate
        };
        return axios.get('/Jobs/DailyBatchHistByDates', { params: newRequestObject })
            .then(r => r.data).catch(loadError('Daily Batch History'));
    };

export const getDailyBatchHistory= () => {
    return axios.get(`/Jobs/DailyBatchHist/`)
            .then(r => r.data).catch(loadError('Daily Batch History'));
    };

export const getRunStatus = (runId) =>
    axios.get(`/api/daily-batch/runs/${runId}/status`)
        .then(r => r.data)
        .catch(loadError('Daily Batch Run Status'));